import { cn } from '@/lib/cn';
import { AIActionButton, type AIActionButtonProps } from './AIActionButton';

/**
 * Convenience wrapper that turns an `<Input>` / `<Textarea>` and its setter
 * into an AI-augmented field. Designed to live in the same row as the input
 * label or float above the textarea.
 *
 * Usage:
 *   <AIFieldAdornment
 *     value={value}
 *     onChange={setValue}
 *     preset="title"
 *     context={{ metadata: { contentSnippet } }}
 *   />
 */
export interface AIFieldAdornmentProps
  extends Omit<AIActionButtonProps, 'getInput' | 'onApply' | 'options'> {
  value: string;
  onChange: (next: string) => void;
  context?: AIActionButtonProps['options'];
  className?: string;
}

export function AIFieldAdornment({
  value,
  onChange,
  context,
  className,
  preset,
  ...rest
}: AIFieldAdornmentProps) {
  return (
    <AIActionButton
      {...rest}
      preset={preset}
      options={context}
      getInput={() => value}
      onApply={(text, meta) => {
        if (meta.format === 'json') {
          onChange(text);
        } else {
          onChange(text);
        }
      }}
      className={cn('shrink-0', className)}
    />
  );
}
